const htmlStringContainsLinks = (html) => {
  const regex = new RegExp("href=");
  return regex.test(html);
};
export {
  htmlStringContainsLinks
};
